/**
 * Storage layer for the active-customer snapshot used by clientsSync.js.
 * Kept import-free so apiClient and authContext can clear it on logout/401
 * without creating a circular dependency.
 */

const STORAGE_KEY = 'kr.activeClientsSnapshot.v1';

// In-memory copy so delta sync keeps working even if localStorage is unavailable/full.
let memorySnapshot = null;

export const readSnapshot = () => {
  if (memorySnapshot) return memorySnapshot;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.clients) || !parsed.watermark || !parsed.fullSyncAt) {
      return null;
    }
    memorySnapshot = parsed;
    return parsed;
  } catch {
    return null;
  }
};

export const writeSnapshot = (snapshot) => {
  memorySnapshot = snapshot;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
  } catch {
    // Quota exceeded or storage unavailable — drop the persisted copy and rely on memory.
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
  }
};

export const clearClientsSnapshot = () => {
  memorySnapshot = null;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
};
